import { DateRange } from "../types/PerformanceTypes";

export const dateInputCls = `
  px-2.5 py-1.5 rounded-lg text-xs font-mono text-gray-700
  border border-slate-200 bg-white
  focus:outline-none focus:border-blue-500 focus:ring-[3px] focus:ring-blue-100
  transition-colors duration-150 w-full sm:w-auto
`;

export const formatDateLabel = (d: string) =>
  new Date(d).toLocaleDateString("fr-FR", { day: "2-digit", month: "short" });

export const fmtFull = (d: string) =>
  new Date(d).toLocaleDateString("fr-FR", {
    day: "2-digit", month: "short", year: "numeric",
  });

export const shiftRangeBack = (range: DateRange): DateRange => {
  const start  = new Date(range.startDate);
  const end    = new Date(range.endDate);
  const diffMs = end.getTime() - start.getTime();
  const prevEnd   = new Date(start.getTime() - 86_400_000);
  const prevStart = new Date(prevEnd.getTime() - diffMs);
  return {
    startDate: prevStart.toISOString().slice(0, 10),
    endDate:   prevEnd.toISOString().slice(0, 10),
  };
};

export const todayStr = () => new Date().toISOString().slice(0, 10);

export const daysAgoStr = (n: number) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
};